import { MSpinner } from "components/Shared";
import { addEmployeePto } from "requests/employee/employeePto";
import React, { useEffect, useRef, useState } from "react";
import MGridForm from "components/Shared/MGridForm";
import validator from "components/Shared/MGridFormDefinitions/validator";
import { DATA_TYPE_DATE, DATA_TYPE_MULTI_LINE_STRING } from "typeConstants/dataTypes";
import { EmployeePto, EmployeePtoDto } from "interfaces/Mueller.Business.Models";
import { Button } from "react-md";

interface PtoAddDialogContentProps {
  employeeId: number,
  onCancelClick: () => void,
  onAddCompleted: () => void,
  onAddErrorCallback: (error: string) => void
}

const emptyFormData: EmployeePtoDto = {
  id: null,
  employeeId: null,
  dateStart: null,
  dateEnd: null,
  notes: null
};

const PtoAddDialogContent = (props: PtoAddDialogContentProps) => {

  const [isAddingPto, setIsAddingPto] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const mounted = useRef<boolean>(true);
  const formControlMethods = useRef(null);
  const requestBody = useRef<EmployeePto>(null);

  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  const formDef = [
      [
        {
          dataType: DATA_TYPE_DATE,
          label: "Date Start",
          source: "dateStart", 
          hasValidationError: validator.required,
        }
      ],
      [
        {
          dataType: DATA_TYPE_DATE,
          label: "Date End",
          source: "dateEnd", 
          hasValidationError: validator.required,
        }
      ],
      [
        {
          dataType: DATA_TYPE_MULTI_LINE_STRING,
          label: "Details",
          source: "notes",
          dataTypeOptions: { defaultLines: 10 }
        }
      ],
    ];

  if (isAddingPto) {
    return <MSpinner />;
  }

  const onSubmitClick = () => {
    if (!formControlMethods.current.isFormValid()) {
      return;
    }
    if(requestBody.current.dateEnd < requestBody.current.dateStart) {
      setErrorMessage("End date cannot be before start date");
      return;
    }
    setIsAddingPto(true);
    addEmployeePto(
      props.employeeId,
      mounted,
      requestBody.current,
      props.onAddCompleted,
      () => {
        setIsAddingPto(false);
        props.onAddErrorCallback("Failed to add PTO, please try again");
      }
    );
  };

  return (
    <div className="pto-add-dialog-content">
      <MGridForm
        formDefinition={formDef}
        getControlMethods={(cm) => formControlMethods.current = cm}
        onChange={(data) => requestBody.current = data}
        data={{ ...emptyFormData }}
      />
      {errorMessage && <div className="add-pto-error-message">{errorMessage}</div>}
      <div className="pto-add-dialog-content-buttons">
        <Button
          primary
          raised
          onClick={onSubmitClick}
        >
          Submit
        </Button>
        <Button
          raised
          onClick={props.onCancelClick}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default PtoAddDialogContent;
